<template>
  <v-menu offset-y v-model="show" nudge-bottom="5" transition="scale-transition" origin="left top"
          :close-on-click="false" :close-on-content-click="false">
    <template v-slot:activator="{on}">
      <v-icon color="warning" v-on="on">mdi-alert</v-icon>
    </template>
    <v-card class="pt-7 px-3" width="480">
      <v-btn icon @click="show=false" small style="position:absolute;right:2px;top:2px"><v-icon>mdi-close</v-icon></v-btn>
      <v-list dense>
        <slot/>
      </v-list>
      <v-switch dense v-model="autoNotification" style="width:240px">
        <template v-slot:label>
          <div class="text-caption">Show notifications automatically</div>
        </template>
      </v-switch>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ListNotification',
  props: {
    value: {type:Boolean, required:false, default:false},
  },
  data() {
    return {
      show: this.value
    }
  },
  computed: {
    autoNotification: {
      get() {
        return !localStorage.getItem('hideNotification');
      },
      set(newValue) {
        if (newValue)
          localStorage.removeItem('hideNotification');
        else
          localStorage.setItem('hideNotification', '1');
      }
    }
  },
  watch: {
    value() {
      this.show = this.value;
    },
    show() {
      this.$emit('input', this.show);
    }
  }
}
</script>